import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js';
import {MenuItem} from './menu-item';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-navigation-column')
export class NavigationColumn extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`

      .column-title {
        align-items: baseline;
        color: var(--color-base);
        display: flex;
        justify-content: space-between;
        font-family: var(--font-family-heading);
        font-size: 1rem;
        font-weight: var(--font-weight-base);
        margin: 0;
      }

      .column-title svg {
        transform: translateY(-3px);
      }

      .column-title.active {
        margin: 0 0 .6rem;
      }

      .column-title.active svg {
        transform: translateY(-3px) scaleY(-1);
      }

      .navigation-column {
        display: none;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      .navigation-column.show {
        display: block;
      }

      .menu-item a {
        display: block;
        padding: .5rem 0;
        text-decoration: none;
      }

      .menu-item p {
        color: var(--color-base);
        font-family: var(--font-family-alternative);
        font-size: .7rem;
        font-weight: var(--font-weight-base);
        margin: 0;
      }

      .menu-item span {
        transition: color .1s linear;
      }

      .menu-item webs-tag {
        margin-left: .5rem;
      }

      .menu-item p:nth-child(2) {
        color: var(--color-grey);
        font-family: var(--font-family-heading);
        font-size: .8rem;
        font-weight: var(--font-weight-base);
        margin-top: .3rem;
      }

      .menu-item a:hover p:first-child span:first-child {
        color: var(--color-primary);
      }

      @media only screen and (min-width: 1175px) {
        .column-title,
        .column-title.active {
          font-family: var(--font-family-alternative);
          font-size: .8rem;
          font-weight: var(--font-weight-strong);
          margin: 0 0 .95rem;
        }

        .navigation-column {
          display: block;
        }

        .column-title svg {
          display: none;
        }

        .menu-item a {
          padding: .65rem 0;
        }
        .menu-item p {
          font-weight: var(--font-weight-semibold);
        }
      }
    `
  ];

  private isNavColumnVisible: boolean;

  @property()
  title;
  @property({type: Array})
  items: MenuItem[];

  protected render(): unknown {
    return html`
      ${this.title ? html`
        <p part="column-title" class="column-title ${this.isNavColumnVisible ? 'active' : ''}" @click=${this.toggleNavColumn}>
          ${this.title}

          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3536 1.35355C13.5488 1.15829 13.5488 0.841709 13.3536 0.646447C13.1583 0.451184 12.8417 0.451184 12.6464 0.646447L13.3536 1.35355ZM7 7L6.64645 7.35355C6.84171 7.54882 7.15829 7.54882 7.35355 7.35355L7 7ZM1.35355 0.646446C1.15829 0.451184 0.841709 0.451184 0.646446 0.646446C0.451184 0.841708 0.451184 1.15829 0.646446 1.35355L1.35355 0.646446ZM12.6464 0.646447L6.64645 6.64645L7.35355 7.35355L13.3536 1.35355L12.6464 0.646447ZM7.35355 6.64645L1.35355 0.646446L0.646446 1.35355L6.64645 7.35355L7.35355 6.64645Z" fill="#181A23"/>
          </svg>
        </p>
      ` : ''}

      ${this.items && this.items.length > 0 ? html`
        <ul class="navigation-column ${!this.title ? 'show' : this.isNavColumnVisible ? 'show' : ''}">
          ${repeat(this.items, (item, index) => html`
            <li class="menu-item">
              <a href="${item.link}" target="${item.openInNewTab ? '_blank': ''}">
                <p>
                  <span>${item.title}</span>
                  ${item.tag ? html`<webs-tag text="${item.tag}"></webs-tag>` : ''}
                </p>
                ${item.description ? html`<p>${item.description}</p>` : ''}
              </a>
            </li>
          `)}
        </ul>` : ''
      }
    `;
  }

  private toggleNavColumn(event: Event): void {
    this.isNavColumnVisible = !this.isNavColumnVisible;
    this.requestUpdate();
  }
}
